export default __webpack_public_path__ + "5906f96c8e85540ae29df5b8862b2a26.svg";